import logo from './logo.svg';
import './App.css';
import FadeUpSection from './components/FadeUpSection'; 
import Nav from './components/Nav';
import Header from './components/Header';
import About from './components/About';
import Skills from './components/Skills';
import Resume from './components/Resume';
import Projects from './components/Projects';
import Footer from './components/Footer';
import Contact from './components/Contact';

function App() {
  const projects = [
    {
        title: '',
        descrption: ''
    }
  ];

  
  return (
    <div className="App">
      <Nav/>
      <Header/>
      <FadeUpSection>
        <About/>
      </FadeUpSection>
      <FadeUpSection>
        <Skills/>
      </FadeUpSection>
      <FadeUpSection>
        <Resume/>
      </FadeUpSection>
      <FadeUpSection>
        <Projects/>
      </FadeUpSection>
      <FadeUpSection>
        <Contact/>
      </FadeUpSection>
      <div className='auxMargin'>
      <FadeUpSection>
        <Footer/>
      </FadeUpSection>
      </div>
    </div>
  );
}

export default App;
